export const InvoiceEditApprovalAction = {
    AddInvIDForEditApproval: "ADDINVIDFOREDITAPPROVAL",
    RemInvIDForEditApproval: "REMINVIDFOREDITAPPROVAL"
}

const InitAddInvID = 0

export const InvoiceEditApprovalReducer = (invIdforEditInv = InitAddInvID, actions) => {
    switch (actions.type) {

        case InvoiceEditApprovalAction.AddInvIDForEditApproval:
            invIdforEditInv = 0;
            invIdforEditInv = actions.payload;
            return invIdforEditInv;

        default:
            return invIdforEditInv;
    }
}